import displayDatatablesPagination from '../shared/datatables_pagination';
import { withSaveState } from '../shared/datatables_state';
import {
  overridePaginationClasses,
  customizeDOMPaginationClasses
} from '../../datatables/customization-v2';
import {
  setup as tableSetup,
  setupPaginationOnDOM,
  tearDownPaginationOnDOM,
  customizePageLength,
  defaultTableOptions
} from '../../datatables/table-setup';

export const POINTS_TABLE_SELECTOR = '.points-table';

const PointsTable = {
  start() {
    const $pointsTable = $(`${POINTS_TABLE_SELECTOR}:not(.dataTable)`);
    if (!$pointsTable.length) {
      return;
    }

    this.startPointsTable($pointsTable);
  },

  tearDown() {
    $(`${POINTS_TABLE_SELECTOR}.dataTable`).DataTable().destroy();
    tearDownPaginationOnDOM();
  },

  startPointsTable($pointsTable) {
    overridePaginationClasses();
    let table;

    const tableOptions = {
      ...defaultTableOptions,
      order: [[3, 'desc']],
      dom: 'rtp',
      columnDefs: [
        { targets: [0], orderable: true, width: '10%' },
        { targets: [1], orderable: true, searchable: true, width: '35%' },
        { targets: [2], orderable: true, width: '15%' },
        { targets: [3], orderable: true, width: '15%' },
        { targets: [4], orderable: true, width: '25%' },
        { targets: '_all', searchable: false }
      ],
      drawCallback() {
        customizePageLength(this);
        customizeDOMPaginationClasses();
        displayDatatablesPagination(this);
      },
      initComplete: () => {
        setupPaginationOnDOM();
      },
      language: {
        ...defaultTableOptions.language,
        zeroRecords: '<span class="alert alert--info">Sorry, no matching Points were found</span>',
        emptyTable: '<span class="alert alert--info">No Points available</span>'
      }
    };

    const tableOptionsWithSaveState = withSaveState($pointsTable, tableOptions);
    table = $pointsTable.DataTable(tableOptionsWithSaveState);
    tableSetup(table);
  }
};

export default PointsTable;
